module.exports = __webpack_public_path__ + "media/00-Presentacion.ff86f85c.mp4";